package link.erpango.quip.data.db

import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.driver.worker.WebWorkerDriver
import link.erpango.quip.db.QuipDb
import org.w3c.dom.Worker

actual class DbDriverFactory {
    actual fun createDriver(): SqlDriver {
        return WebWorkerDriver(createWorker())
    }

    actual suspend fun createDriverJs(): SqlDriver {
        return WebWorkerDriver(createWorker())
    }
}

private fun createWorker(): Worker = js("new Worker(new URL('sql-worker.js', import.meta.url), { type: 'module' })")
